module.exports = __webpack_public_path__ + "img/vai_logo_mark.aa95f6f8.png";